import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './with-tooltip.styl';

@VODCSSModules(styles)
export default class WithTooltip extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    tooltip: React.PropTypes.any,
    className: React.PropTypes.string,
    innerClassName: React.PropTypes.string,
  };

  renderTooltip() {
    const { tooltip, innerClassName } = this.props;

    return (
      <span styleName="tooltip">
        <span className={innerClassName}
              styleName="tooltip-inner">
          {tooltip}
        </span>
      </span>
    );
  }

  render() {
    const { tooltip, children, className } = this.props;

    if (!children) {
      return null;
    }

    return (
      <span className={className}
            styleName="with-tooltip">
        {tooltip && this.renderTooltip()}
        {children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/with-tooltip/with-tooltip.js